"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _memoizeOne = _interopRequireDefault(require("memoize-one")),
    _makeRequest = _interopRequireDefault(require("./makeRequest"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var source, i = 1; i < arguments.length; i++) {
    source = null == arguments[i] ? {} : arguments[i], i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2["default"])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var mapRequests = (0, _memoizeOne["default"])(function (client, requests, promptWelcomeGuestLogin, promptRequestAccess) {
  return Object.keys(requests).reduce(function (mappedRequests, requestKey) {
    var _requests$requestKey = requests[requestKey],
        mutation = _requests$requestKey.mutation,
        query = _requests$requestKey.query,
        module = _requests$requestKey.module,
        buildVariables = _requests$requestKey.buildVariables,
        ignoreCache = _requests$requestKey.ignoreCache,
        requestFn = mutation ? client.mutate : client.query;
    return _objectSpread({}, mappedRequests, (0, _defineProperty2["default"])({}, requestKey, function (input) {
      return (0, _makeRequest["default"])(requestFn, {
        mutation: mutation,
        query: query,
        fetchPolicy: ignoreCache ? "network-only" : void 0,
        context: {
          module: module
        },
        variables: buildVariables(input)
      }, promptWelcomeGuestLogin, promptRequestAccess);
    }));
  }, {});
}),
    _default = mapRequests;
exports["default"] = _default;